import { Text, VStack } from '@chakra-ui/react';

type EmptyStateProps = {
  title: string;
  description: string;
};

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
}) => (
  <VStack spacing={4} align="center" textAlign="center" py={10}>
    <Text
      fontSize="24px"
      fontWeight="bold"
      fontFamily="marketingPage"
      color="content.title">
      {title}
    </Text>
    <Text
      fontSize="16px"
      color="content.muted"
      fontFamily="marketingPage"
      maxW="500px">
      {description}
    </Text>
  </VStack>
);
